import React from 'react';

const CalendarLock = props => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" {...props}>
    <g clipPath="url(#a)">
      <g stroke="#647A85" strokeLinecap="round" strokeLinejoin="round" clipPath="url(#b)">
        <path d="M12.5 18.5h-11a1 1 0 0 1-1-1v-14a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v6M5.5.501v5M15.5.501v5M.5 7.501h20" />
        <path d="M15.5 15.501h7s1 0 1 1V22.5s0 1-1 1h-7s-1 0-1-1v-5.999s0-1 1-1Z" />
        <path d="M17.75 19.564a1.25 1.25 0 1 0 2.5 0 1.25 1.25 0 0 0-2.5 0ZM21.5 14a2.5 2.5 0 0 0-5 0v1.5h5V14Z" />
      </g>
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
      <clipPath id="b">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);

export default CalendarLock;
